module.exports = __webpack_public_path__ + "static/img/0001眼保健2.6dc7d19.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/0001眼保健2.jpg
// module id = UKN/
// module chunks = 0